import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '../utils/cn';

type ButtonVariant = 'primary' | 'secondary' | 'ghost';
type ButtonSize = 'md' | 'lg';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: ButtonVariant;
  size?: ButtonSize;
};

const variantClasses: Record<ButtonVariant, string> = {
  primary:
    'border border-black/65 bg-[#08090c] text-white shadow-none hover:border-white/35 hover:bg-[#141820] focus-visible:outline-[#08090c] disabled:border-black/40 disabled:bg-[#2b2f39] disabled:text-white/60',
  secondary:
    'border border-black/65 bg-[#08090c] text-white shadow-none hover:border-white/35 hover:bg-[#141820] focus-visible:outline-[#08090c] disabled:border-black/40 disabled:bg-[#2b2f39] disabled:text-white/60',
  ghost:
    'border border-black/65 bg-[#08090c] text-white shadow-none hover:border-white/35 hover:bg-[#141820] focus-visible:outline-[#08090c] disabled:border-black/40 disabled:bg-[#2b2f39] disabled:text-white/60',
};

const sizeClasses: Record<ButtonSize, string> = {
  md: 'h-11 px-5 text-sm',
  lg: 'h-12 px-6 text-base',
};

export function Button({
  children,
  className,
  variant = 'primary',
  size = 'md',
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-[10px] font-semibold transition duration-200 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed',
        variantClasses[variant],
        sizeClasses[size],
        className
      )}
      type={type}
      {...props}
    >
      {children}
    </button>
  );
}
